<div class="container mt-4">
  <div class="card shadow-sm">
    <div class="table-responsive p-3">

      <!-- Header & ADD Button -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h4 class="mb-0">Checker Approval</h4>
        
      </div>
       <div class="mb-3 text-center">
    
       <!-- <button type="submit" class="btn btn-submit" (click)="GetOnboardingGrid()" >Onboarding Data</button>
        <button type="submit" class="btn btn-reject" (click)="GetOffboardingGrid()" >Offboarding Data</button>-->
      <!-- Employee Table -->
       <div class="row mb-4">
       <div class="table-responsive modern-table-container">
  <table class="table table-bordered table-hover">
        <thead class="table-dark">
          <tr>
            <th>#</th>
            <th>Action</th>
            <th>Emp Code</th>
            <th>Full Name</th>
            <th>Designation</th>
            <th>Location</th>
            <th>Department</th>
            <th>Dongle Sim</th>
            <th>BioMetric card</th>
            <th>Mobile Sim</th>
            <th>AD Username</th>
            <th>Mail ID</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let emp of RevokeGrid; let i = index">
            <!-- Index -->
            <td>{{ i + 1 }}</td>

            <!-- Action Dropdown -->
            <td class="text-center"><div class="Dropdown">
              <button class="icon-button me-1" ([ngModel])="appservice.FinalRevokeEdit" (click)="editEmployee(emp.IR_iid)" title="Edit">
    <img src="assets/images/edit.png" alt="Edit" width="20" height="20">
  </button>
  </div>
            </td>

            <!-- Data Columns -->
            <td>{{ emp.IR_EmployeeId }}</td>
            <td>{{ emp.IR_Fullname }}</td>
            <td>{{ emp.IR_Designation }}</td>
            <td>{{ emp.IR_Grade }}</td>
            <td>{{ emp.IR_Department }}</td>
            <td>{{ emp.IR_Dongle_SimCard }}</td>
            
            
            <td>{{ emp.IR_Biometric_card }}</td>
            <td>{{ emp.IR_Mobilesim }}</td>
            
            <td>{{ emp.IR_ADUserName }}</td>
            <td>{{ emp.IR_ADMailId }}</td>
          </tr>
        </tbody>
      </table>
</div>
</div>
    </div>
  </div>
</div>
